import React from "react";
import Breadcrumb from "../../components/Reusable/Breadcrumb";
import ProfileItemLink from "../Profile/ProfileItemLink";
import { t } from "i18next"; // Import t function for translation

const Settings = () => {
  return (
    <div className="settings-main-container">
      <Breadcrumb title={t("settings.title")} returnPage="/profile" />
      <div className="settings-list-items">
        <ProfileItemLink
          title={t("settings.profileChange")}
          link={"/profile-change"}
          image={"/images/change-profile.png"}
        />
        <ProfileItemLink
          title={t("settings.changePassword")}
          link={"/change-password"}
          image={"/images/change-password.png"}
        />
        <ProfileItemLink
          title={t("settings.changeLanguage")}
          link={"/language"}
          image={"/images/change-language.png"}
        />
        {/* <ProfileItemLink
          title={t("settings.deleteAccount")}
          image={"/images/delete-acc.png"}
        /> */}
      </div>
    </div>
  );
};

export default Settings;
